var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 62,
    viewBox: "0 0 70 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0338 0.936031L1.64535 18.2176C1.20398 18.5917 1.43507 19.3939 1.98421 19.3939H68.0147C68.5638 19.3939 68.7949 18.5917 68.3535 18.2176L47.965 0.936031C47.867 0.852909 47.7482 0.808044 47.6262 0.808044H22.3727C22.2507 0.808044 22.1319 0.852909 22.0338 0.936031Z",
    fill: "url(#gem_paint0_linear_284_478)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4621 1.74825L2.64876 18.4538H67.3512L47.5378 1.74825H22.4621ZM21.6016 0.298632C21.8316 0.104682 22.1103 0 22.3965 0H47.6034C47.8896 0 48.1683 0.104685 48.3983 0.298626L47.9417 1.0012L48.3983 0.298631L68.7492 17.4574C69.7845 18.3303 69.2425 20.202 67.9544 20.202H2.04556C0.757441 20.202 0.215401 18.3303 1.2507 17.4574L21.6016 0.298632Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9412 60.405L1.57177 20.4898C1.22667 20.077 1.48331 19.3939 1.98351 19.3939H68.7224C69.2226 19.3939 69.4793 20.077 69.1342 20.4898L52.7017 40.1457L35.7647 60.405C35.5406 60.6731 35.1654 60.6731 34.9412 60.405Z",
    fill: "url(#gem_paint1_linear_284_478)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81928 20.3313L35 59.567L68.1807 20.3313H1.81928ZM0.374884 21.1531C-0.442917 20.1861 0.165256 18.5858 1.3506 18.5858H68.6494C69.8347 18.5858 70.4429 20.1861 69.6251 21.1531L35.9757 60.9431C35.4446 61.5711 34.5554 61.5711 34.0243 60.9431L0.374884 21.1531Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.627 0L23.0634 0.610903L17.2289 18.8928L36.0607 59.7764L34.7092 60.6061L15.5557 19.024L21.627 0Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8702 0L47.3843 0.610903L53.4199 18.8928L33.9388 59.7764L35.3369 60.6061L55.1509 19.024L48.8702 0Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gem_paint0_linear_284_478",
    x1: 34.9994,
    y1: 0.808044,
    x2: 34.9994,
    y2: 19.3939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gem_paint1_linear_284_478",
    x1: 35.353,
    y1: 19.3939,
    x2: 35.353,
    y2: 60.8975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/gem.4627f04be2f07bd24e91365b83823b4e.svg";
export { ForwardRef as ReactComponent };